import script from "./middle2.vue?vue&type=script&setup=true&lang=js"
export * from "./middle2.vue?vue&type=script&setup=true&lang=js"

import "./middle2.vue?vue&type=style&index=0&id=72fc374c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72fc374c"]])

export default __exports__